import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/(other)/parents/ParentLayout.tsx");
